import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";

import { IKanbanTodoItem } from "../../models/Vehicle";

export default function VehicleWorkflowCell({ workflow }: { workflow: IKanbanTodoItem[] | undefined }) {
  const { t } = useTranslation("vehicles");

  if (!workflow?.length) {
    return <span className="text-xs text-gray-400">—</span>;
  }

  return (
    <ul className="flex flex-col gap-1 min-w-[11rem]">
      {workflow.map((step) => (
        <li
          key={step.label}
          className={`flex items-center gap-1.5 text-[11px] ${step.complete ? "text-gray-400" : "text-gray-700 font-medium"}`}
        >
          {step.complete ? (
            <CheckCircleIcon className="h-3.5 w-3.5 flex-shrink-0 text-green-500" />
          ) : (
            <span className="h-3 w-3 flex-shrink-0 rounded-full border border-gray-400" />
          )}
          <span className={step.complete ? "line-through" : ""}>{t(step.label)}</span>
        </li>
      ))}
    </ul>
  );
}
